import React, { useState, useContext } from "react";
import axios from "axios";
import Button from "../button/Button";
import TranslateContext from "../../context/TranslateContext";
import "./From.css";

const From = () => {
  const translateCtx = useContext(TranslateContext);
  const [enteredText, setEnteredText] = useState("");

  const textChangeHandler = (e) => {
    setEnteredText(e.target.value);
    translateCtx.setEnteredText(e.target.value);
  };

  const performTranslation = async () => {
    try {
      const response = await axios.get(
        `https://translate.timpetrvalsky.com/translate/?from=${enteredText}&lang=${translateCtx.language}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { translation } = response.data;
      translateCtx.setTransText(translation);
      setEnteredText("");
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    performTranslation();
  };

  const handleClick = () => {
    performTranslation();
  };

  return (
    <div>
      <div className="search-one-container">
        <h1>From English:</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="inputFrom"
            name="fromText"
            value={enteredText}
            onChange={textChangeHandler}
          />
        </form>
      </div>
      <Button value="Translate" type="button" onClick={handleClick} />
    </div>
  );
};

export default From;
